import { createAction } from "@ngrx/store";
import { Jurisdiction } from "@obg/core.config";

import { GeoFencingErrorType } from "./geofencing.model";

const ACTION_PREFIX = "[GeoFencing]";

export namespace GeoFencingAction {
	export const validateLocation = createAction(`${ACTION_PREFIX} check location`);

	export const validateBrazilLocation = createAction(`${ACTION_PREFIX} Brazil check location`);

	export const validateLocationSuccess = createAction(
		`${ACTION_PREFIX} validate location success`,
		(valid: boolean, error?: GeoFencingErrorType) => ({ valid, error })
	);

	export const validateArgentineLocationSuccess = createAction(
		`${ACTION_PREFIX} validate Argentine location success`,
		(valid: boolean, locationId: string | undefined) => ({ valid, locationId })
	);

	export const validateLocationFailure = createAction(
		`${ACTION_PREFIX} validate location failure`,
		(error?: GeoFencingErrorType | undefined) => ({ error })
	);

	export const validateIpLocationSuccess = createAction(
		`${ACTION_PREFIX} validate IP location success`,
		(valid: boolean) => ({ valid })
	);

	export const validateIpLocationFailure = createAction(
		`${ACTION_PREFIX} validate IP location failure`,
		(error: GeoFencingErrorType) => ({ error })
	);

	export const getArgentinaLocationSuccess = createAction(
		`${ACTION_PREFIX} get Argentina location success`,
		(position: GeolocationPosition) => ({ position })
	);

	export const getBrazilLocationSuccess = createAction(
		`${ACTION_PREFIX} get Brazil location success`,
		(isFraud: boolean, error?: GeoFencingErrorType) => ({ isFraud, error })
	);

	export const getAwsLocationSuccess = createAction(
		`${ACTION_PREFIX} get Canada location success`,
		(position: GeolocationPosition) => ({ position })
	);

	export const getAwsIpLocation = createAction(`${ACTION_PREFIX} get Canada IP location success`);

	export const setWageringBlockDialogEnabled = createAction(
		`${ACTION_PREFIX} set wagering block dialog flag`,
		(wageringBlockDialogEnabled: boolean) => ({ wageringBlockDialogEnabled })
	);

	export const resetError = createAction(`${ACTION_PREFIX} reset error`);

	export const showErrorAlert = createAction(`${ACTION_PREFIX} show error alert`, (jurisdiction: Jurisdiction) => ({
		jurisdiction,
	}));
}
